import _styled, { default as _styled2, default as _styled3, default as _styled4, default as _styled5, default as _styled6, default as _styled7, default as _styled8, default as _styled9 } from "styled-components";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { observer } from "mobx-react";
import { Component, Fragment } from "react";
import { Translation, withTranslation } from "react-i18next";
import styled, { withTheme } from "styled-components";
import { PaneMode } from "../../../ReactViewModels/defaultHelpContent";
import Box from "../../../Styled/Box";
import Button, { RawButton } from "../../../Styled/Button";
import { GLYPHS, StyledIcon } from "../../../Styled/Icon";
import Select from "../../../Styled/Select";
import Spacing from "../../../Styled/Spacing";
import Text, { TextSpan } from "../../../Styled/Text";
import measureElement from "../../HOCs/measureElement";
import { withViewState } from "../../Context";
import { applyTranslationIfExists } from "../../../Language/languageHelpers";
import StyledHtml from "../../Map/Panels/HelpPanel/StyledHtml";
import CloseButton from "../../Generic/CloseButton";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const TrainerBarWrapper = styled(Box).withConfig({
  displayName: "TrainerBar__TrainerBarWrapper",
  componentId: "sc-1p3ekuu-0"
})(["top:0;left:", "px;z-index:", ";"], p => p.isMapFullScreen ? 0 : Number(p.theme.workbenchWidth) + Number(p.theme.workbenchMargin) * 2, p => Number(p.theme.frontComponentZIndex) + 100);

// Help with discoverability
const BoxTrainerExpandedSteps = styled(Box).withConfig({
  displayName: "TrainerBar__BoxTrainerExpandedSteps",
  componentId: "sc-1p3ekuu-1"
})([""]);
var _StyledBoxTrainerExpandedSteps = styled(BoxTrainerExpandedSteps).withConfig({
  displayName: "TrainerBar___StyledBoxTrainerExpandedSteps",
  componentId: "sc-1p3ekuu-2"
})(["padding-bottom:10px;top:", "px;max-height:calc(100vh - ", "px - 20px);"], p => p.$_css2, p => p.$_css3);
const getSelectedTrainerFromHelpContent = (viewState, helpContent) => {
  const selected = viewState.selectedTrainerItem;
  const found = helpContent.find(item => item.itemName === selected);
  // Try and find the item that we selected, otherwise find the first trainer pane
  return found || helpContent.find(item => item.paneMode === PaneMode.trainer);
};

// Ripped from StyledHtml.jsx
const Numbers = styled(Text).withConfig({
  displayName: "TrainerBar__Numbers",
  componentId: "sc-1p3ekuu-3"
})(["width:22px;height:22px;line-height:22px;border-radius:50%;background-color:", ";"], props => props.theme.textLight);
const StepText = styled(Text).attrs({}).withConfig({
  displayName: "TrainerBar__StepText",
  componentId: "sc-1p3ekuu-4"
})(["ol,ul{padding:0;margin:0;padding-left:17px;}li{padding-left:8px;}"]);
const renderStep = function (step, number, viewState) {
  var _options$footerCompon;
  let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
    renderDescription: true,
    comfortable: false,
    footerComponent: undefined
  };
  return /*#__PURE__*/_jsxs(Box, {
    paddedVertically: true,
    children: [/*#__PURE__*/_jsxs(Box, {
      alignItemsFlexStart: true,
      children: [/*#__PURE__*/_jsx(Numbers, {
        textDarker: true,
        textAlignCenter: true,
        darkBg: true,
        children: number
      }), /*#__PURE__*/_jsx(Spacing, {
        right: 3
      })]
    }), /*#__PURE__*/_jsxs(Box, {
      column: true,
      children: [/*#__PURE__*/_jsx(Translation, {
        children: (_t, _ref) => {
          let {
            i18n
          } = _ref;
          return /*#__PURE__*/_jsx(Text, {
            textLight: true,
            extraExtraLarge: true,
            semiBold: true,
            children: applyTranslationIfExists(step.title, i18n)
          });
        }
      }), options.renderDescription && (step === null || step === void 0 ? void 0 : step.markdownDescription) && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(Spacing, {
          bottom: options.comfortable ? 2 : 1
        }), /*#__PURE__*/_jsx(StepText, {
          medium: true,
          textLightDimmed: true,
          children: /*#__PURE__*/_jsx(StyledHtml, {
            viewState: viewState,
            styledTextProps: {
              textDark: false,
              textLightDimmed: true
            },
            markdown: step.markdownDescription
          })
        })]
      }), (_options$footerCompon = options.footerComponent) === null || _options$footerCompon === void 0 ? void 0 : _options$footerCompon.call(options)]
    })]
  }, number);
};
const renderOrderedStepList = function (steps, viewState) {
  return steps.map((step, index) => /*#__PURE__*/_jsxs(Fragment, {
    children: [renderStep(step, index + 1, viewState), index + 1 !== steps.length && /*#__PURE__*/_jsx(Spacing, {
      bottom: 3
    })]
  }, index));
};
// Originally written as a SFC but measureElement only supports class components at the moment
class StepAccordionRaw extends Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "refToMeasure", void 0);
  }
  render() {
    const {
      viewState,
      selectedTrainerSteps,
      t,
      theme,
      selectedTrainer,
      isShowingAllSteps,
      setIsShowingAllSteps,
      isExpanded,
      setIsExpanded,
      heightFromMeasureElementHOC
    } = this.props;
    return /*#__PURE__*/_jsxs(Box, {
      centered: !isExpanded,
      fullWidth: true,
      justifySpaceBetween: true
      // onMouseOver={() => setIsPeeking(true)}
      ,
      children: [/*#__PURE__*/_jsx(_StyledBox, {
        paddedHorizontally: 4,
        column: true,
        "aria-hidden": isExpanded,
        overflow: "hidden",
        ref: component => {
          if (!isExpanded) this.refToMeasure = component;
        },
        children: renderStep(selectedTrainerSteps[viewState.currentTrainerStepIndex], viewState.currentTrainerStepIndex + 1, viewState, {
          renderDescription: false,
          comfortable: true
        })
      }), isExpanded && /*#__PURE__*/_jsx(_StyledBox2, {
        paddedHorizontally: 4,
        column: true,
        position: "absolute",
        fullWidth: true,
        backgroundColor: theme.darkMid,
        ref: component => this.refToMeasure = component,
        children: renderStep(selectedTrainerSteps[viewState.currentTrainerStepIndex], viewState.currentTrainerStepIndex + 1, viewState, {
          renderDescription: true,
          comfortable: true,
          footerComponent: () => /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx(Spacing, {
              bottom: 3
            }), /*#__PURE__*/_jsx(RawButton, {
              onClick: () => setIsShowingAllSteps(!isShowingAllSteps),
              title: isShowingAllSteps ? t("trainer.hideAllSteps") : t("trainer.showAllSteps"),
              children: /*#__PURE__*/_jsx(TextSpan, {
                medium: true,
                primary: true,
                isLink: true,
                textAlignLeft: true,
                children: isShowingAllSteps ? t("trainer.hideAllSteps") : t("trainer.showAllSteps")
              })
            })]
          })
        })
      }), /*#__PURE__*/_jsx(Box, {
        paddedHorizontally: 2,
        children: /*#__PURE__*/_jsx(_StyledRawButton, {
          onClick: () => setIsExpanded(!isExpanded)
          // onMouseOver={() => setIsPeeking(true)}
          // onFocus={() => setIsPeeking(true)}
          ,
          title: isExpanded ? t("trainer.collapseTrainer") : t("trainer.expandTrainer")
          // onBlur={() => {
          //   if (!isExpanded) setIsPeeking(false);
          // }}
          ,
          $_css: "z-index:2;",
          children: /*#__PURE__*/_jsx(StyledIcon, {
            styledWidth: "26px",
            light: true,
            glyph: isExpanded ? GLYPHS.accordionClose : GLYPHS.accordionOpen
          })
        })
      }), isShowingAllSteps && /*#__PURE__*/_jsxs(_StyledBoxTrainerExpandedSteps, {
        column: true,
        position: "absolute",
        backgroundColor: theme.darkMid,
        fullWidth: true,
        paddedRatio: 4,
        overflowY: "auto",
        $_css2: heightFromMeasureElementHOC,
        $_css3: heightFromMeasureElementHOC,
        children: [renderOrderedStepList(selectedTrainerSteps, viewState), selectedTrainer.footnote ? /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(Spacing, {
            bottom: 3
          }), /*#__PURE__*/_jsx(Text, {
            medium: true,
            textLightDimmed: true,
            children: /*#__PURE__*/_jsx(StyledHtml, {
              viewState: viewState,
              styledTextProps: {
                textDark: false,
                textLightDimmed: true
              },
              markdown: selectedTrainer.footnote
            })
          })]
        }) : /*#__PURE__*/_jsx(Spacing, {
          bottom: 3
        })]
      })]
    });
  }
}
const StepAccordion = withTranslation()(withViewState(measureElement(StepAccordionRaw)));
export const TrainerBar = observer(props => {
  const {
    i18n,
    t,
    theme,
    viewState
  } = props;
  const terria = viewState.terria;
  const {
    helpContent
  } = terria.configParameters;

  // All these null guards are because we are rendering based on nested
  // map-owner defined (helpContent)content which could be malformed
  if (!viewState.trainerBarVisible || !helpContent) {
    return null;
  }
  const selectedTrainer = getSelectedTrainerFromHelpContent(viewState, helpContent);
  const selectedTrainerItems = selectedTrainer === null || selectedTrainer === void 0 ? void 0 : selectedTrainer.trainerItems;
  if (!selectedTrainerItems) {
    return null;
  }
  const trainerItemIndex = viewState.currentTrainerItemIndex <= selectedTrainerItems.length ? viewState.currentTrainerItemIndex : 0;
  const selectedTrainerItem = selectedTrainerItems[trainerItemIndex];
  const selectedTrainerSteps = selectedTrainerItem === null || selectedTrainerItem === void 0 ? void 0 : selectedTrainerItem.steps;
  if (!selectedTrainerSteps) {
    return null;
  }
  const isMapFullScreen = viewState.isMapFullScreen;
  return /*#__PURE__*/_jsx(TrainerBarWrapper, {
    centered: true,
    position: "absolute",
    styledWidth: isMapFullScreen ? "100%" : "calc(100% - ".concat(Number(Number(theme.workbenchWidth) + Number(theme.workbenchMargin) * 2), "px)"),
    isMapFullScreen: isMapFullScreen,
    onClick: () => viewState.setTopElement("TrainerBar"),
    children: /*#__PURE__*/_jsxs(Box, {
      fullWidth: true,
      fullHeight: true,
      centered: true,
      justifySpaceBetween: true,
      backgroundColor: theme.darkMid,
      children: [/*#__PURE__*/_jsx(_StyledBox3, {
        $_css4: "min-height: 64px;",
        children: /*#__PURE__*/_jsx(_StyledSelect, {
          paddingForLeftIcon: "45px",
          leftIcon: () => /*#__PURE__*/_jsx(_StyledStyledIcon, {
            light: true,
            styledWidth: "21px",
            glyph: GLYPHS.oneTwoThree,
            $_css5: "padding-left:15px;"
          }),
          onChange: e => viewState.setCurrentTrainerItemIndex(Number(e.target.value)),
          value: viewState.currentTrainerItemIndex
          // css={"min-width: 280px;"}
          ,
          children: selectedTrainerItems.map((item, index) => /*#__PURE__*/_jsx("option", {
            value: index,
            children: applyTranslationIfExists(item.title, i18n)
          }, item.title))
        })
      }), /*#__PURE__*/_jsx(StepAccordion, {
        selectedTrainerSteps: selectedTrainerSteps,
        isShowingAllSteps: viewState.trainerBarShowingAllSteps,
        setIsShowingAllSteps: bool => viewState.setTrainerBarShowingAllSteps(bool),
        isExpanded: viewState.trainerBarExpanded,
        setIsExpanded: bool => viewState.setTrainerBarExpanded(bool),
        selectedTrainer: selectedTrainerItem,
        theme: theme
      }), /*#__PURE__*/_jsx(Spacing, {
        right: 4
      }), /*#__PURE__*/_jsxs(Box, {
        children: [/*#__PURE__*/_jsx(_StyledButton, {
          secondary: true,
          shortMinHeight: true,
          onClick: () => {
            viewState.setCurrentTrainerStepIndex(viewState.currentTrainerStepIndex - 1);
          },
          $_css6: theme.textLight,
          $_css7: theme.textLight,
          $_css8: viewState.currentTrainerStepIndex === 0 && "visibility: hidden;",
          children: t("general.back")
        }), /*#__PURE__*/_jsx(Spacing, {
          right: 2
        }), /*#__PURE__*/_jsx(_StyledButton2, {
          primary: true,
          shortMinHeight: true,
          onClick: () => {
            viewState.setCurrentTrainerStepIndex(viewState.currentTrainerStepIndex + 1);
          },
          $_css9: viewState.currentTrainerStepIndex === selectedTrainerSteps.length - 1 && "visibility: hidden;",
          children: t("general.next")
        }), /*#__PURE__*/_jsx(Spacing, {
          right: 5
        }), /*#__PURE__*/_jsx(Box, {
          centered: true,
          children: /*#__PURE__*/_jsx(CloseButton, {
            noAbsolute: true
            // topRight
            ,
            color: theme.textLight,
            onClick: () => viewState.setTrainerBarVisible(false)
          })
        }), /*#__PURE__*/_jsx(Spacing, {
          right: 6
        })]
      })]
    })
  });
});
export default withTranslation()(withViewState(withTheme(TrainerBar)));
var _StyledBox = styled(Box).withConfig({
  displayName: "TrainerBar___StyledBox",
  componentId: "sc-1p3ekuu-5"
})(["max-height:64px;pointer-events:none;"]);
var _StyledBox2 = styled(Box).withConfig({
  displayName: "TrainerBar___StyledBox2",
  componentId: "sc-1p3ekuu-6"
})(["top:0;padding-bottom:20px;padding-right:60px;"]);
var _StyledRawButton = styled(RawButton).withConfig({
  displayName: "TrainerBar___StyledRawButton",
  componentId: "sc-1p3ekuu-7"
})(["", ""], p => p.$_css);
var _StyledBox3 = styled(Box).withConfig({
  displayName: "TrainerBar___StyledBox3",
  componentId: "sc-1p3ekuu-8"
})(["", ""], p => p.$_css4);
var _StyledSelect = styled(Select).withConfig({
  displayName: "TrainerBar___StyledSelect",
  componentId: "sc-1p3ekuu-9"
})(["width:290px;@media (max-width:", "px){width:84px;color:transparent;}"], p => p.theme.lg);
var _StyledStyledIcon = styled(StyledIcon).withConfig({
  displayName: "TrainerBar___StyledStyledIcon",
  componentId: "sc-1p3ekuu-10"
})(["", ""], p => p.$_css5);
var _StyledButton = styled(Button).withConfig({
  displayName: "TrainerBar___StyledButton",
  componentId: "sc-1p3ekuu-11"
})(["background:transparent;color:", ";border-color:", ";", ""], p => p.$_css6, p => p.$_css7, p => p.$_css8);
var _StyledButton2 = styled(Button).withConfig({
  displayName: "TrainerBar___StyledButton2",
  componentId: "sc-1p3ekuu-12"
})(["", ""], p => p.$_css9);